@import "src/styles/common/colors.scss";


.rdpStartCalendar .react-datepicker__day:hover,
.rdpStartCalendar .react-datepicker__month-text:hover,
.rdpStartCalendar .react-datepicker__year-text:hover {
    color: $white;
    background-color: $start-date-selected-bc;
}

.rdpEndCalendar .react-datepicker__day:hover,
.rdpEndCalendar .react-datepicker__month-text:hover,
.rdpEndCalendar .react-datepicker__year-text:hover {
    color: $white;
    background-color: $end-date-selected-bc;
}


.reactDatepickerCustomHeaderButton {
    cursor: pointer;
    padding: 5px;
    color: $white;
    background: linear-gradient(180deg, $date-picker-lightgrey 0, $date-picker-darkgrey);
    border: 0px;
}

.reactDatepickerCustomHeaderButton {
    &.rdpChbMiddle {
        flex: 1;
    }

    &:disabled {
        color: $gray-variant-11;
        cursor: no-drop;
    }
}


.reactDatepickerCustomHeaderButton {
    &:hover {
        background: linear-gradient(180deg, $cal-switch-lightgreen 0, $cal-switch-darkgreen) !important;

        &:disabled {
            background: linear-gradient(180deg, $date-picker-lightgrey 0, $date-picker-darkgrey) !important;
        }
    }
}



.reactDatepickerActionsWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dateRangeWrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 410px;
    max-width: 410px;
    background-color: $date-range-wrapper-bc;
    padding: 10px !important;
    border-radius: 4px;
    border: 1px solid $date-range-wrapper-border;
}

.calendarComponentWrapper {
    position: absolute;
    z-index: 1000;
    line-height: normal;
}

.positionNotOneDay {
    left: -190px;
    top: 43px;
}

.positionOneDay {
    left: -92.5px;
    top: 43.5px;
}

.dateRangeWrapper.drwOneDay {
    min-width: 215px;
    max-width: 255px;
}

.dateRangeWrapperArrow {
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid $black;
}

.dateRangeCalendarsWrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
}

.calendarWrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
}

.rdpCalendarTitle {
    display: flex;
    justify-content: left;
    align-items: center;
    padding-left: 2px;
    gap: 5px;
}

.rdpCalendarTitleLegend {
    width: 10px;
    height: 10px;
    border-radius: 2px;
}

.rdpCalendarTitleLegend {
    &.rdpCtlStartDate {
        background-color: $start-date-color;
    }
}

.rdpCalendarTitleLegend {
    &.rdpCtlEndDate {
        background-color: $end-date-color;
    }
}

.rdpCalendarTitleTitle {
    font-size: 11px;
    text-align: left;
    color: $white;
    margin: 0px;
}

.calendarBtn {
    padding: 4px 6px !important;

    >span {
        font-size: 1rem;
    }
}

.react-datepicker-custom-header-button {
    &.rdpChbMiddle {
        flex: 1;
    }
}

.rdpActionsSelectedRangeText {
    font-size: 12px;
    color: $white;
}

.rdpActionsSubmitButton {
    padding: 5px;
    text-align: center;
    border-radius: 3px;
    font-weight: 700;
    color: $white;
    text-shadow: 0 1px 1px rgb(0 0 0 / 55%);
    box-shadow: 0 1px 1px hsl(0deg 0% 100% / 30%);
    cursor: pointer;
    border: 1px solid $cloud-blue;
    background: linear-gradient(180deg, $date-picker-btn-bc0 0, $date-picker-btn-bc1)
}